var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "birthday_nav_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", [_vm._v("选择展示样式")]),
      _c(
        "el-form-item",
        {
          staticClass: "show_type",
          attrs: {
            prop: "show_type",
            rules: [
              {
                required: true,
                message: "请先选择一种样式",
                trigger: "change",
              },
            ],
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.typeList, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  class: [
                    "type-box",
                    item.id == _vm.value.config.show_type && "checked",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeType(item)
                    },
                  },
                },
                [
                  _c("el-image", {
                    staticClass: "img",
                    attrs: { fit: "contain", src: item.imageurl },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "menu" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择生日类型一级菜单")]),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [{ required: true, message: "一级菜单不可为空" }],
                prop: "category_id",
              },
            },
            [
              _vm.parentKey
                ? _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.menuListFilter,
                      props: {
                        label: "show_name",
                        value: "id",
                        children: "childrens",
                        checkStrictly: true,
                        emitPath: false,
                      },
                      disabled: "",
                      "collapse-tags": "",
                      filterable: "",
                      placeholder: "选择生日类型一级菜单",
                    },
                    on: { change: _vm.changeCategory },
                    model: {
                      value: _vm.value.config.category_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "category_id", $$v)
                      },
                      expression: "value.config.category_id",
                    },
                  })
                : _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "选择生日类型一级菜单",
                        clearable: "",
                        filterable: "",
                      },
                      on: { change: _vm.changeCategory },
                      model: {
                        value: _vm.value.config.category_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "category_id", $$v)
                        },
                        expression: "value.config.category_id",
                      },
                    },
                    _vm._l(_vm.menuListFilter, function (menu) {
                      return _c("el-option", {
                        key: menu.id,
                        attrs: {
                          label: menu.show_name,
                          value: menu.id,
                          disabled: menu.disabled,
                        },
                      })
                    }),
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      [1, 3].includes(_vm.value.config.show_type)
        ? _c(
            "el-form-item",
            { attrs: { prop: "is_open_ad", label: "插入广告" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.is_open_ad,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "is_open_ad", $$v)
                    },
                    expression: "value.config.is_open_ad",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("开启")]),
                  _c("el-radio", { attrs: { label: "0" } }, [_vm._v("关闭")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.value.config.is_open_ad === "1"
        ? _vm._l(_vm.value.config.ads, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "upload-item" },
              [
                _c(
                  "div",
                  { staticClass: "upload" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "ads." + index + ".imageurl",
                          rules: [{ required: true, message: "图片不可为空" }],
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-item-wrap" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner",
                              refInFor: true,
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: item.imageurl,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: {
                                emitUploadFile: function (res) {
                                  return _vm.emitUploadFile(res, item)
                                },
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "btns" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.onUpload(index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 上传图片 ")]
                                ),
                                _vm.pictureList.length > 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectPicture(index)
                                          },
                                        },
                                      },
                                      [_vm._v(" 选择图片 ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c("div", { staticClass: "tips" }, [
                      _vm._v(
                        " 建议尺寸为宽度" +
                          _vm._s(
                            _vm.value.config.show_type === 1 ? "330" : "220"
                          ) +
                          "px，高度等比例展示，支持png、gif格式图 "
                      ),
                    ]),
                  ],
                  1
                ),
                _c("config-menu", {
                  key: item.uid,
                  attrs: {
                    propName: "ads",
                    value: item,
                    type: _vm.value.key,
                    index: index,
                    info: _vm.info,
                    menuList: _vm.menuList,
                    childrenMenuList: _vm.childrenMenuList,
                    customerModuleList: _vm.customerModuleList,
                    eBookCategoryList: _vm.eBookCategoryList,
                    aBookCategoryList: _vm.aBookCategoryList,
                    customerPackageList: _vm.customerPackageList,
                    systemMenus: _vm.systemMenus,
                  },
                }),
              ],
              1
            )
          })
        : _vm._e(),
      !_vm.parentKey
        ? [
            _c("div", { staticClass: "label" }, [
              _vm._v(" 设置分类及排序 "),
              _c("span", { staticClass: "tips" }, [
                _vm._v("（拖动分类可调整排序）"),
              ]),
            ]),
            _c(
              "draggable",
              {
                attrs: { animation: "500", "force-fallback": true },
                model: {
                  value: _vm.value.config.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "value", $$v)
                  },
                  expression: "value.config.value",
                },
              },
              _vm._l(_vm.value.config.value, function (item, index) {
                return _c(
                  "div",
                  { key: item.id, class: ["box", !item.flag && "disabled"] },
                  [
                    _c(
                      "div",
                      { staticClass: "list" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(" " + _vm._s(item.primitiveName) + " "),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { margin: "0" },
                            attrs: { prop: "value." + index + ".flag" },
                          },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                              },
                              on: { change: _vm.changeSwitch },
                              model: {
                                value: item.flag,
                                callback: function ($$v) {
                                  _vm.$set(item, "flag", $$v)
                                },
                                expression: "item.flag",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "list" },
                      [
                        _c("div", { staticClass: "label nickName" }, [
                          _vm._v(" 展示为 "),
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "value." + index + ".name",
                              rules: [
                                {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.checkList(
                                      rule,
                                      value,
                                      callback,
                                      item.flag
                                    )
                                  },
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", disabled: !item.flag },
                              model: {
                                value: item.name,
                                callback: function ($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "showType" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("商品展示逻辑")]),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [{ required: true, message: "商品展示逻辑不可为空" }],
                prop: "sort",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.sort,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "sort", $$v)
                    },
                    expression: "value.config.sort",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v(" 按商品列表默认排序（即按商品ID大到小） "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v(" 按商品更新时间倒序展示（更新时间晚到早） "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: "3" } }, [
                        _vm._v(
                          " 按商品排序值正序展示（即按商品排序值小到大） "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.parentKey
        ? _c(
            "el-form-item",
            {
              staticClass: "margin_top",
              attrs: {
                prop: "margin_top",
                rules: [{ type: "number", message: "间距必须为数字值" }],
              },
            },
            [
              _c("div", [_vm._v(" 与上方组件的间距 ")]),
              _c("el-input", {
                attrs: { placeholder: "请输入间距", clearable: "" },
                model: {
                  value: _vm.value.config.margin_top,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
                  },
                  expression: "value.config.margin_top",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.parentKey
        ? _c(
            "el-form-item",
            {
              staticClass: "z_index",
              attrs: {
                prop: "z_index",
                rules: [
                  {
                    required: true,
                    pattern: /^(?:[1-9]|[1-9][0-9])$/,
                    message: "请输入1-99之间的整数！",
                  },
                ],
              },
            },
            [
              _c("div", [_vm._v(" 层级高度值 ")]),
              _c("el-input", {
                attrs: { placeholder: "请输入层级高度值", clearable: "" },
                model: {
                  value: _vm.value.config.z_index,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
                  },
                  expression: "value.config.z_index",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }